import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { useCallback, useRef, useState } from 'react';
export const DragArea = ({ handleDrop, enabled, children, shouldShowBorder, ...rest }) => {
    const [dragVisible, setDragIsVisible] = useState(false);
    const dragCount = useRef(0); // Manages dragLeave events from children
    const dataAttributes = useDataAttributes(rest);
    const onDragEnter = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        dragCount.current += 1;
        setDragIsVisible(true);
        return false;
    }, []);
    const onDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }, []);
    const onDragLeave = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        dragCount.current -= 1;
        if (dragCount.current === 0) {
            setDragIsVisible(false);
        }
        return false;
    }, []);
    const onDrop = useCallback((e) => {
        e.preventDefault();
        const { files } = e.dataTransfer;
        if (!files) {
            return false;
        }
        handleDrop(files);
        dragCount.current = 0;
        setDragIsVisible(false);
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!enabled) {
        return _jsx("div", { ...dataAttributes, children: children });
    }
    return (_jsxs("div", { className: buildClassName('skyline-text-body-1 border-primary-blue relative h-full bg-white', shouldShowBorder ? 'rounded-sm border-2 border-dashed' : 'border-none'), onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDragOver: onDragOver, onDrop: onDrop, role: "complementary", ...dataAttributes, children: [dragVisible && _jsx("div", { className: " bg-primary-blue/10 absolute inset-0 z-50" }), children] }));
};
export default DragArea;
//# sourceMappingURL=DragArea.js.map